var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./checkbox-button.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2d19f1dd\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./checkbox-button.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/CheckboxButton/checkbox-button.vue.html
// module id = N4Wd
// module chunks = 2